export const SET_REPORT_TYPIFICATIONS = "SET_REPORT_TYPIFICATIONS";
export const SET_REPORT_MANAGEMENT = "SET_REPORT_MANAGEMENT";
export const SET_REPORT_TIME_PLATFORM = "SET_REPORT_TIME_PLATFORM";
export const SET_COMMON_REPORTS = "SET_COMMON_REPORTS";
export const SET_REPORT_DETAIL_TIME_PLATFORM = "SET_REPORT_DETAIL_TIME_PLATFORM";
export const SET_REPORT_CALLS_ANSWERED = "SET_REPORT_CALLS_ANSWERED";
export const SET_REPORT_CALLS_INCOMING = "SET_REPORT_CALLS_INCOMING";
